import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  public themeState$ = new BehaviorSubject<string | undefined>(undefined);

  async switchTheme(theme?: string): Promise<void> {
    if (theme && this.themeState$.getValue() !== theme) {
      this.removeCurrentTheme();
      await this.loadTheme(theme);
      this.themeState$.next(theme)
    } else if (!theme) {
      this.removeCurrentTheme();
      this.themeState$.next(undefined)
    }
  }

  private async loadTheme(theme: string): Promise<boolean> {
    const linkElement = document.createElement('link');
    linkElement.rel = 'stylesheet';
    linkElement.href = `assets/themes/${theme}/_variables.css`;
    linkElement.id = 'customer-theme';
    const preload = (await fetch(linkElement.href)).ok
    document.head.appendChild(linkElement);
    return preload
  }

  private removeCurrentTheme(): void {
    const existingLinkElement = document.getElementById('customer-theme');
    if (existingLinkElement) {
      existingLinkElement.remove();
    }
  }
}
